import { Home, Briefcase, FileText, Palette, Building2, Plug, FolderPlus } from 'lucide-react';
import type { NavigationItem } from '../types/SideMenu.types';

export type StartupNavSection =
  | 'home'
  | 'work-scopes'
  | 'artifacts'
  | 'files'
  | 'design-system'
  | 'startup-profile'
  | 'integrations';

/**
 * Build the startup-level sidebar nav items from a single `activeSection` and
 * per-section navigation callbacks. Each callback is optional; sections without a
 * callback render disabled.
 */
export const buildStartupNavItems = (opts: {
  activeSection: StartupNavSection;
  onNavigateToHome?: () => void;
  onNavigateToWorkScopes?: () => void;
  onNavigateToArtifacts?: () => void;
  onNavigateToFiles?: () => void;
  onNavigateToDesignSystem?: () => void;
  onNavigateToStartupProfile?: () => void;
  onNavigateToIntegrations?: () => void;
}): NavigationItem[] => [
  {
    id: 'home',
    label: 'Home',
    icon: Home,
    isActive: opts.activeSection === 'home',
    disabled: !opts.onNavigateToHome,
    type: 'navigation',
    testId: 'sidemenu-home',
    onClick: opts.onNavigateToHome,
  },
  {
    id: 'work-scopes',
    label: 'Work Scopes',
    icon: Briefcase,
    isActive: opts.activeSection === 'work-scopes',
    disabled: !opts.onNavigateToWorkScopes,
    type: 'navigation',
    testId: 'sidemenu-work-scopes',
    onClick: opts.onNavigateToWorkScopes,
  },
  {
    id: 'artifacts',
    label: 'Artifacts',
    icon: FileText,
    isActive: opts.activeSection === 'artifacts',
    disabled: !opts.onNavigateToArtifacts,
    type: 'navigation',
    testId: 'sidemenu-artifacts',
    onClick: opts.onNavigateToArtifacts,
  },
  {
    id: 'files',
    label: 'Files',
    icon: FolderPlus,
    isActive: opts.activeSection === 'files',
    disabled: !opts.onNavigateToFiles,
    type: 'navigation',
    testId: 'sidemenu-files',
    onClick: opts.onNavigateToFiles,
  },
  {
    id: 'design-system',
    label: 'Design system',
    icon: Palette,
    isActive: opts.activeSection === 'design-system',
    disabled: !opts.onNavigateToDesignSystem,
    type: 'navigation',
    testId: 'sidemenu-design-system',
    onClick: opts.onNavigateToDesignSystem,
  },
  {
    id: 'startup-profile',
    label: 'Startup Profile',
    icon: Building2,
    isActive: opts.activeSection === 'startup-profile',
    disabled: !opts.onNavigateToStartupProfile,
    type: 'navigation',
    testId: 'sidemenu-startup-profile',
    onClick: opts.onNavigateToStartupProfile,
  },
  {
    id: 'integrations',
    label: 'Integrations',
    icon: Plug,
    isActive: opts.activeSection === 'integrations',
    disabled: !opts.onNavigateToIntegrations,
    type: 'navigation',
    testId: 'sidemenu-integrations',
    onClick: opts.onNavigateToIntegrations,
  },
];
